export default "__VITE_ASSET__Cd4K1f_z__"